export interface NominatimResult {
    lat: string;
    lon: string;
    display_name: string;
    address?: any;
}

const sleep = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

async function fetchWithRetry(url: string, retries: number = 2, backoff: number = 2000): Promise<any> {
    for (let i = 0; i <= retries; i++) {
        try {
            const res = await fetch(url, {
                headers: {
                    'Accept': 'application/json',
                    // Nominatim requires a user-agent to avoid blocking
                    'User-Agent': 'MyCarCosts/1.0 (contact@example.com)'
                }
            });
            if (!res.ok) {
                if (res.status === 429) { // Rate limit
                    throw new Error('Rate limit exceeded');
                }
                throw new Error(`HTTP error ${res.status}`);
            }
            return await res.json();
        } catch (err) {
            if (i === retries) {
                throw err;
            }
            await sleep(backoff);
        }
    }
}

export async function searchAddress(query: string): Promise<NominatimResult[]> {
    if (!query || query.trim().length < 3) return [];
    const url = `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(query)}&addressdetails=1&limit=5`;
    return fetchWithRetry(url);
}

export async function reverseGeocode(lat: number, lon: number): Promise<NominatimResult | null> {
    const url = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}&zoom=18&addressdetails=1`;
    try {
        const result = await fetchWithRetry(url);
        if (result && !result.error) {
            return result;
        }
        return null;
    } catch (err) {
        console.error("Reverse geocoding error:", err);
        return null;
    }
}
